import { Link } from 'react-router-dom';
import { SignedIn, SignedOut, UserButton } from '@clerk/clerk-react';
import { motion } from 'framer-motion';
import styles from './Header.module.css';

export function Header() {
  return (
    <motion.header
      className={styles.header}
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.4, ease: [0.4, 0, 0.2, 1] }}
    >
      <div className={styles.container}>
        <Link to="/" className={styles.logo}>
          <img
            src="/favicon.svg"
            alt="Omen SEO"
            className={styles.logoImage}
          />
          <span className={styles.logoText}>Omen SEO</span>
        </Link>

        <nav className={styles.nav}>
          <Link to="/#pricing" className={styles.navLink}>Pricing</Link>
          <SignedOut>
            <Link to="/sign-in" className={styles.navLink}>Sign In</Link>
            <Link to="/sign-up" className="btn btn-primary btn-sm">Get Started</Link>
          </SignedOut>
          <SignedIn>
            <Link to="/dashboard" className={styles.navLink}>Dashboard</Link>
            <Link to="/subscription" className={styles.navLink}>Billing</Link>
            <UserButton
              afterSignOutUrl="/"
              appearance={{
                elements: {
                  avatarBox: {
                    width: 32,
                    height: 32
                  }
                }
              }}
            />
          </SignedIn>
        </nav>
      </div>
    </motion.header>
  );
}
